import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable } from 'rxjs';

import { CmsQueryList, CmsTaxonomy } from '@fcom/core-api';

@Component({
  selector: 'fin-teaser-list',
  templateUrl: './teaser-list.component.html',
  styleUrls: ['./teaser-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeaserListComponent {
  public readonly TAXONOMY: typeof CmsTaxonomy = CmsTaxonomy;

  @Input()
  content$: Observable<CmsQueryList>;
}
